import { Fragment } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import logo from "../../../Assets/images/newLogo.png"
import style from "./navbar.module.css"


export default function NavbarOnline() {
   const navigate = useNavigate();

   //& Handle Log Out :
   function logOut() {
      localStorage.removeItem("provider_token")
      navigate("/onlineSystem")
   }

   return (
      <Fragment>
         <nav className=" navbar navbar-expand p-0 bgBlack fixed-top mb-5 pt-1" id="navbar">
            <div className="container p-0 ">
               {/* <Link className="navbar-brand h1 " to="#"><span className="navbar-brand h1">Fekrah Medical Company</span></Link> */}
               <Link className={`navbar-brand text-black ${style.div_logo}`} to="/onlineSystem/"><img src={logo} alt="logo" className="w-100 h-100 " /></Link>

               <div className="collapse navbar-collapse" id="navbarSupportedContent">

                  {localStorage.getItem("provider_token") != null ?
                     <>

                        <ul className="navbar-nav ms-auto bgBlack mb-lg-0 ">
                           <li className="nav-item">
                              <NavLink className="nav-link text-white" to="transportation"> <i className="fa-solid fa-house mx-2"></i><span >Approvals</span></NavLink>
                           </li>

                           <li className="nav-item">
                              <NavLink className="nav-link text-white" aria-current="page" to="approvedSearch"> <i className="fa-solid fa-layer-group mx-2"></i> <span >Search For Approvals</span></NavLink>
                           </li>
                        </ul>


                        <ul className="navbar-nav ms-auto mb-lg-0 d-flex align-items-center justify-content-between">
                           <Link onClick={() => { logOut() }} className="btn btn_log m-2 text-white" to="/onlineSystem">Log Out <i class="fa-solid fa-right-from-bracket mx-2"></i></Link>
                        </ul>
                     </> : <>
                        <ul className="navbar-nav ms-auto mb-lg-0 d-flex align-items-center justify-content-between">
                           <Link className="navbar-brand text-white h1" to="/onlineSystem/"><span className="navbar-brand text-black h1">Approval Online System The <span className="header-title-text main-color">TREND</span> Company </span></Link>
                        </ul>
                     </>}

               </div>

            </div>
         </nav>
      </Fragment>
   )
}